<h2 mat-dialog-title>{{ data.title | translate }}</h2>
<mat-label>{{ data.text | translate }}</mat-label>
<mat-dialog-actions align="end">
  <button
    [disableRipple]="true"
    mat-raised-button
    color="accent"
    (click)="okHandleClick()"
  >
    Ok
  </button>
</mat-dialog-actions>
